var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.keys)?_c('div',{staticClass:"icons flex_cen_cen"},[_c('img',{staticClass:"icon_centes",attrs:{"src":_vm.jsons[_vm.keys],"alt":"","srcset":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }